module.exports = __webpack_public_path__ + "components/ServicesCategories/icons/zgloszenia.svg?ebd86248";


//////////////////
// WEBPACK FOOTER
// ./components/ServicesCategories/icons/zgloszenia.svg
// module id = 1870
// module chunks = 0